
<app-navbar></app-navbar>
<main class="main-content">
  <router-outlet></router-outlet>
</main>
<app-footer style="padding: 0 1em;"></app-footer>
<div *ngIf="showWhats" class="whats-modal-content">
  <button (click)="closeWhats()" class="btn-fechar-whats">
    X
  </button>
  <div style="display: flex; justify-content: space-between; background-color: #1e806a; height: 70px; align-items: flex-start; border-radius: 3px;">
    <img style="width: 50px; height: 50px; position: relative; top: 8px; left: 9px;" src="https://d335luupugsy2.cloudfront.net/cms/files/199144/1675430913/$bub8ax8kbvk" alt="">
    <span class="text-header-whats">Blukit - Soluções Hidráulicas</span>
    <span style="color: #fff; position: absolute; top: 36px; left: 72px; font-size: 14px; font-weight: bold;">Online</span>
</div>
<textarea *ngIf="!collectiveVacation" disabled id="w3review" name="w3review" rows="2" cols="50" class="hellow-whats">
  Olá, lojista! Informe seu nome para que possamos conversar melhor! 😊
</textarea>
<textarea *ngIf="collectiveVacation" disabled id="w3review" name="w3review" rows="4" cols="50" style="line-height: 1.3;font-size: 14px; width: 70%; padding: 1em; margin: 1em; background-color: #fff; overflow: hidden; resize: none;">
  Olá, lojista! Estamos aproveitando um período de descanso coletivo. Retornaremos cheios de energia e prontos para atendê-lo a partir do dia 09/01/2024! 😊
</textarea>
<form action="" [formGroup]="formWhatsApp" (submit)="onSubmit()">
  <input id="form-wp-name"
  formControlName="nome"
  type="text"
  placeholder="Nome *"
  class="input-form-wpp"
  [class.error]="
                formWhatsApp.controls['nome'].errors &&
                (formWhatsApp.controls['nome'].dirty ||
                formWhatsApp.controls['nome'].touched ||
                submitted
  )">
   <span
   class="text-danger error-wpp"
   *ngIf="formWhatsApp.controls['nome'].errors?.['required'] && (formWhatsApp.controls['nome'].dirty || (formWhatsApp.controls['nome'].touched) || submitted)"
 >
   Nome é necessário.
 </span>
 <span
   class="text-danger error-wpp"
   *ngIf="!formWhatsApp.controls['nome'].errors?.['required'] && (formWhatsApp.controls['nome'].dirty || (formWhatsApp.controls['nome'].touched) || submitted) && formWhatsApp.controls['nome'].errors"
 >
   Nome inválido.
 </span>
  <input id="form-wp-telefone"
  formControlName="telefone"
  type="text" placeholder="Telefone *"
  class="input-form-wpp"
  [class.error]="
                formWhatsApp.controls['telefone'].errors &&
                (formWhatsApp.controls['telefone'].dirty ||
                formWhatsApp.controls['telefone'].touched ||
                submitted
  )"
  >
  <span
  class="text-danger error-wpp"
  *ngIf="formWhatsApp.controls['telefone'].errors?.['required'] && (formWhatsApp.controls['telefone'].dirty || (formWhatsApp.controls['telefone'].touched)|| submitted)"
>
  Telefone é necessário.
</span>
<span
  class="text-danger error-wpp"
  *ngIf="!formWhatsApp.controls['telefone'].errors?.['required'] && (formWhatsApp.controls['telefone'].dirty || (formWhatsApp.controls['telefone'].touched)|| submitted) && formWhatsApp.controls['telefone'].errors"
>
  Telefone inválido.
</span>
  <input id="form-wp-email"
  formControlName="email"
  type="text" placeholder="Email *"
  class="input-form-wpp"
  [class.error]="
                formWhatsApp.controls['email'].errors &&
                (formWhatsApp.controls['email'].dirty ||
                formWhatsApp.controls['email'].touched ||
                submitted
  )">
  <span class="text-danger error-wpp"
  *ngIf="formWhatsApp.controls['email'].errors?.['required'] && (formWhatsApp.controls['email'].dirty || (formWhatsApp.controls['email'].touched)|| submitted)">
  E-mail é necessário.
</span>
<span class="text-danger error-wpp"
  *ngIf="!formWhatsApp.controls['email'].errors?.['required'] && (formWhatsApp.controls['email'].dirty || (formWhatsApp.controls['email'].touched)|| submitted) && formWhatsApp.controls['email'].errors">
  E-mail inválido.
</span>
  <input id="form-wp-cnpj"
  formControlName="cnpj"
  type="text" placeholder="CNPJ *"
  class="input-form-wpp"
  [class.error]="
                formWhatsApp.controls['cnpj'].errors &&
                (formWhatsApp.controls['cnpj'].dirty ||
                formWhatsApp.controls['cnpj'].touched ||
                submitted
  )">
    <span class="text-danger error-wpp"
    *ngIf="formWhatsApp.controls['cnpj'].errors?.['required'] && (formWhatsApp.controls['cnpj'].dirty || (formWhatsApp.controls['cnpj'].touched)|| submitted)">
    CNPJ é necessário.
  </span>
  <span class="text-danger error-wpp"
    *ngIf="!formWhatsApp.controls['cnpj'].errors?.['required'] && (formWhatsApp.controls['cnpj'].dirty || (formWhatsApp.controls['cnpj'].touched)|| submitted) && formWhatsApp.controls['cnpj'].errors">
    CNPJ inválido.
  </span>
<button type="submit" class="btn-start-conversation">
  Iniciar Conversa
</button>
</form>
</div>
<a class="icon-whatsapp" (click)="showWhats = !showWhats" target="_blank" rel="noopener noreferrer">
    <img src="/assets/icons/whatsapp_62px.png" alt="">
</a>

<div class="container-fluid bg bg-light text-center p-4" style="font-size: 12px;">
  <span style="cursor: pointer;" (click)="openLgpd()">Lei Geral de Proteção de Dados (LGPD) / Política de Privacidade</span>
</div>

<div *ngIf="!cookiesAccepted" class="accept-cookies p-4">
  <div class="area-lgpd">
    <p class="title-lgpd">Políticas de Privacidade e Proteção de Dados</p>
    <p class="text-lgpd">Esta página faz uso de cookies para melhorar sua experiência de navegação em nossos serviços. Em concordância com as Leis  de Proteção de Dados, é necessário que você aceite o uso deste recurso para que possa visitar o site. Você pode saber mais sobre nossa Política de Privacidade e Proteção de dados pessoais nos links abaixo.
    <br> <span>Para avançar clique no botão “Aceitar”</span>
  </p>
  <div class="d-flex flex-wrap gap-2">
    <a href="https://www.blukit.com.br/Politica-de-Privacidade-Blukit.pdf" target="_blank" class="card-cod-pro-home ler-lgpd">Ler Políticas de Privacidade</a>
    <a (click)="acceptCookies()" class="card-cod-pro-home aceitar-lgpd">Aceitar</a>
  </div>
  </div>
</div>
